import { getCookieValue } from "helpers/cookies"
import { MARKETING_FIELDS, PHONE_PREFIX } from "helpers/constants"
import { newOpportunity } from "services/leadsService"
import { sendLeadEvent as sendLeadToGA } from "scripts/GoogleAnalytics"
import { sendLeadEvent as sendLeadToBing } from "scripts/BingAds"
import { sendLead as sendLeadToFB } from "scripts/FacebookPixel"
import { sendLead as sendLeadToGoogleAds } from "scripts/GoogleAds"
import { personTracking } from "scripts/Sentry"
import { getClientFingerprint } from "../lib/fingerprint"

export default function createNewOpportunity(leadParams, formName, locale) {
  const extraParams = calculateParams(leadParams, formName, locale)
  // if (process.env.NODE_ENV === "development") return {}

  return newOpportunity({ ...leadParams, ...extraParams }).then(data => onSuccess(data, leadParams, formName))
}

function calculateParams(leadParams, formName, locale) {
  const { phone, promotionalCode, car_id, landing } = leadParams

  const marketingParams = {}
  MARKETING_FIELDS.forEach(field => {
    marketingParams[field] = getCookieValue(field)
  })

  let kind = "call_me"
  if (car_id) kind = "leasing_car"
  if (leadParams.utm_multistep) kind = "multistep"
  if (formName === "vassla") kind = "vassla"

  const countryCode = window.countryCode !== "404" ? window.countryCode : "ES"

  return {
    phone: `${PHONE_PREFIX[countryCode] || "+34"}${phone}`,
    promotional_code: promotionalCode,
    country_code: countryCode,
    time_zone: typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "Europe/Madrid",
    accepts_conditions: true,
    code: getClientFingerprint(),
    kind,
    locale,
    formName,
    utm_conversion_page: formName,
    ...marketingParams,
    // Special case as origin is both an API param and a marketing param
    origin: (marketingParams.origin === "vipdistrict" ? "vipdistrict" : landing) || "swipcar"
  }
}

const onSuccess = (data, leadParams, formName) => {
  const { email, car_id, utm_multistep, sellingStatus } = leadParams
  const isMultistep = Boolean(utm_multistep)
  const isOnline = Boolean(data.last_web_leasing_request_id)

  sendLeadToGA(email, isOnline, isMultistep, formName, sellingStatus)

  if (formName !== "vassla") {
    sendLeadToBing(email)
    sendLeadToFB()
    sendLeadToGoogleAds(car_id, isMultistep)
  }

  personTracking(data)

  return data
}
